function normalizeText(value) {
  return String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim();
}

export function normalizeInventoryComponent(value) {
  return normalizeText(value);
}

export function normalizeInventoryItemName(value) {
  return normalizeText(value);
}

export function contextualInventorySlot(scopedCatalog = [], mappedItems = [], workingComponent = '', selectedCatalogId = '') {
  const catalog = Array.isArray(scopedCatalog) ? scopedCatalog : [];
  const mapped = Array.isArray(mappedItems) ? mappedItems.filter(Boolean) : [];
  const selected = String(selectedCatalogId || '').trim();

  if (selected) {
    const selectedMapped = mapped.find(item => String(item?.catalogId || '').trim() === selected);
    if (selectedMapped) return { item: selectedMapped, needsMapping: false, reason: 'selected' };
  }

  const component = normalizeInventoryComponent(workingComponent);
  if (!component) return null;

  const componentMapped = mapped.filter(item => normalizeInventoryComponent(item?.component) === component);
  if (componentMapped.length === 1) {
    return { item: componentMapped[0], needsMapping: false, reason: 'working-component' };
  }
  if (componentMapped.length > 1) return null;

  // A product may have only been learned in one pouch so far. If every known
  // mapping points to the same product name and this container has exactly one
  // matching slot in the pouch currently being worked, infer that slot and let
  // the caller teach the barcode library the additional pouch mapping.
  const mappedNames = [...new Set(mapped.map(item => normalizeInventoryItemName(item?.item)).filter(Boolean))];
  if (mappedNames.length !== 1) return null;

  const contextualSlots = catalog.filter(item =>
    normalizeInventoryComponent(item?.component) === component
    && normalizeInventoryItemName(item?.item) === mappedNames[0]
  );
  if (contextualSlots.length !== 1) return null;

  const contextual = contextualSlots[0];
  const alreadyMapped = mapped.some(item => String(item?.catalogId || '').trim() === String(contextual?.catalogId || '').trim());
  return { item: contextual, needsMapping: !alreadyMapped, reason: 'working-component-product' };
}
